import { api } from '../../../renderer/services/http';

export const invoiceService = {
  getAll: async () => api<any[]>('/api/purchase/invoices'),
  create: async (body: any, post = false) =>
    api('/api/purchase/invoices', { method: 'POST', body: JSON.stringify({ ...body, post }) }),
  post: async (id: string) => api(`/api/purchase/invoices/${id}/post`, { method: 'POST' }),
};

export const paymentService = {
  getAll: async () => api<any[]>('/api/purchase/payments'),
  create: async (body: any) => api('/api/purchase/payments', { method: 'POST', body: JSON.stringify(body) }),
};
